export const getSessionId = () => {
  const session = localStorage.getItem("auth_token");
  return session ? session : null;
};
